/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

const indianCityList = ["Abohar",
  "Achalpur",
  "Adilabad",
  "Adityapur",
  "Adoni",
  "Agartala",
  "Agra",
  "Ahmadnagar",
  "Ahmedabad",
  "Aizawl",
  "Ajmer",
  "Akbarpur",
  "Akola",
  "Alandur",
  "Alappuzha",
  "Aligarh",
  "Allahabad",
  "Alwar",
  "Ambala",
  "Ambala Sadar",
  "Ambattur",
  "Ambernath",
  "Ambikapur",
  "Ambur",
  "Amravati",
  "Amreli",
  "Amritsar",
  "Amroha",
  "Anand",
  "Anantapur",
  "Anantnag",
  "Arrah",
  "Asansol",
  "Ashokenagar Kalyangarh",
  "Auli",
  "Aurangabad (Bihar)",
  "Aurangabad (Maharashtra)",
  "Avadi",
  "Azamgarh",
  "Badalapur",
  "Bagaha",
  "Bagalkot",
  "Bahadurgarh",
  "Baharampur",
  "Bahraich",
  "Baidyabati",
  "Baleshwar",
  "Ballia",
  "Bally",
  "Bally Town",
  "Balurghat",
  "Banda",
  "Bangalore",
  "Bankura",
  "Bansberia",
  "Banswara",
  "Baran",
  "Baranagar",
  "Barasat",
  "Baraut",
  "Barddhaman",
  "Bareilly",
  "Baripada",
  "Barnala",
  "Barrackpur",
  "Barshi",
  "Basirhat",
  "Basti",
  "Batala",
  "Bathinda",
  "Beawar",
  "Begusarai",
  "Belgaum",
  "Bellary",
  "Bettiah",
  "Betul",
  "Bhadrak",
  "Bhadravati",
  "Bhadreswar",
  "Bhagalpur",
  "Bhalswa Jahangir Pur",
  "Bharatpur",
  "Bharuch",
  "Bhatpara",
  "Bhavnagar",
  "Bhilai Nagar",
  "Bhilwara",
  "Bhimavaram",
  "Bhind",
  "Bhiwadi",
  "Bhiwandi",
  "Bhiwani",
  "Bhopal",
  "Bhubaneswar",
  "Bhuj",
  "Bhusawal",
  "Bid",
  "Bidar",
  "Bidhan Nagar",
  "Biharsharif",
  "Bijapur",
  "Bikaner",
  "Bilaspur (Himachal Pradesh)",
  "Bilaspur (Chattisgarh)",
  "Bokaro Steel",
  "Bongaon",
  "Botad",
  "Brahmapur Town",
  "Budaun",
  "Bulandshahr",
  "Bundi",
  "Burari",
  "Burhanpur",
  "Buxar",
  "Chamba (Himachal Pradesh)",
  "Chamba (Uttarakhand)",
  "Champdani",
  "Chandannagar",
  "Chandausi",
  "Chandigarh",
  "Chandrapur",
  "Chapra",
  "Chas",
  "Chennai",
  "Chhattarpur",
  "Chhindwara",
  "Chikmagalur",
  "Chilakaluripet",
  "Chitradurga",
  "Chittaurgarh",
  "Chittoor",
  "Churu",
  "Coimbatore",
  "Cuddalore",
  "Cuttack",
  "Dabgram",
  "Dallo Pura",
  "Damoh",
  "Darbhanga",
  "Darjiling",
  "Datia",
  "Davanagere",
  "Deesa",
  "Dehradun",
  "Dehri",
  "Delhi",
  "Delhi Cantonment",
  "Deoghar",
  "Deoli",
  "Deoria",
  "Dewas",
  "Dhanbad",
  "Dharmavaram",
  "Dharamshala",
  "Dhaulpur",
  "Dhule",
  "Dibrugarh",
  "Dimapur",
  "Dinapur Nizamat",
  "Dindigul",
  "Dum Dum",
  "Durg",
  "Durgapur (West Bengal)",
  "Durgapur (Maharashtra)",
  "Eluru",
  "English Bazar",
  "Erode",
  "Etah",
  "Etawah",
  "Faizabad",
  "Faridabad",
  "Farrukhabad and Fatehgarh",
  "Fatehabad (Haryana)",
  "Fatehabad (Uttar Pradesh)",
  "Fatehabad (Madhya Pradesh)",
  "Fatehpur",
  "Firozabad",
  "Firozpur",
  "Gadag and Betigeri",
  "Gandhidham",
  "Gandhinagar",
  "Ganganagar",
  "Gangapur",
  "Gangawati",
  "Gangtok",
  "Gaya",
  "Ghaziabad",
  "Ghazipur",
  "Giridih",
  "Godhra",
  "Gokal Pur",
  "Gonda",
  "Gondal",
  "Gondiya",
  "Gorakhpur",
  "Greater Noida",
  "Gudivada",
  "Gulbarga",
  "Guna",
  "Guntakal",
  "Guntur",
  "Gurgaon",
  "Guwahati",
  "Gwalior",
  "Habra",
  "Hajipur",
  "Haldia",
  "Haldwani and Kathgodam",
  "Halisahar",
  "Hamirpur (Uttar Pradesh)",
  "Hamirpur (Himachal Pradesh)",
  "Hanumangarh",
  "Haora",
  "Hapur",
  "Hardoi",
  "Haridwar",
  "Hassan",
  "Hastsal",
  "Hathras",
  "Hazaribag",
  "Hindaun",
  "Hindupur",
  "Hinganghat",
  "Hisar",
  "Hoshangabad",
  "Hoshiarpur",
  "Hospet",
  "Hosur",
  "Hubli and Dharwad",
  "Hugli and Chinsurah",
  "Hyderabad",
  "Ichalkaranji",
  "Imphal",
  "Indore",
  "Islampur (Bihar)",
  "Islampur (West Bengal)",
  "Jabalpur",
  "Jagadhri",
  "Jagdalpur",
  "Jaipur",
  "Jalandhar",
  "Jalgaon",
  "Jalna",
  "Jalpaiguri",
  "Jamalpur",
  "Jammu",
  "Jamnagar",
  "Jamshedpur",
  "Jamuria",
  "Jaunpur",
  "Jehanabad",
  "Jetpur Navagadh",
  "Jhansi",
  "Jhunjhunun",
  "Jind",
  "Jodhpur",
  "Junagadh",
  "Kadapa",
  "Kaithal",
  "Kakinada",
  "Kalol",
  "Kalyan and Dombivali",
  "Kalyani",
  "Kamarhati",
  "Kancheepuram",
  "Kanchrapara",
  "Kannur",
  "Kanpur",
  "Kanpur Cantonment",
  "Kapurthala",
  "Karaikkudi",
  "Karawal Nagar",
  "Karimnagar",
  "Karnal",
  "Kasganj",
  "Kashipur",
  "Katihar",
  "Khammam",
  "Khandwa",
  "Khanna",
  "Kharagpur (Bihar)",
  "Kharagpur (West Bengal)",
  "Khardaha",
  "Khargone",
  "Khora",
  "Khurja",
  "Kirari Suleman Nagar",
  "Kishanganj",
  "Kishangarh",
  "Kochi",
  "Kolapur",
  "Kolar",
  "Kolkata",
  "Kollam",
  "Korba",
  "Kota (Rajasthan)",
  "Kota (Uttar Pradesh)",
  "Kota (Karnataka)",
  "Kozhikode",
  "Krishnanagar",
  "Kulti",
  "Kumbakonam",
  "Kurichi",
  "Kurnool",
  "Lakhimpur",
  "Lalitpur",
  "Latur",
  "Loni",
  "Lucknow",
  "Ludhiana",
  "Machilipatnam",
  "Madanapalle",
  "Madavaram",
  "Madhyamgram",
  "Madurai",
  "Mahbubnagar",
  "Mahesana",
  "Maheshtala",
  "Mainpuri",
  "Malappuram",
  "Malegaon",
  "Malerkotla",
  "Manali",
  "Mussorie",
  "Mandoli",
  "Mandsaur",
  "Mandya",
  "Mangalore",
  "Mango",
  "Mathura",
  "Maunath Bhanjan",
  "Medinipur",
  "Meerut",
  "Mira and Bhayander",
  "Miryalaguda",
  "Mirzapur and Vindhyachal",
  "Modinagar",
  "Moga",
  "Mohali",
  "Moradabad",
  "Morena",
  "Morvi",
  "Motihari",
  "Mughalsarai",
  "Muktsar",
  "Mumbai",
  "Munger",
  "Murwara",
  "Mustafabad",
  "Muzaffarnagar",
  "Muzaffarpur",
  "Mysore",
  "Nabadwip",
  "Nadiad",
  "Nagaon",
  "Nagapattinam",
  "Nagaur",
  "Nagda",
  "Nagercoil",
  "Nagpur",
  "Naihati",
  "Nalgonda",
  "Nanded Waghala",
  "Nandurbar",
  "Nandyal",
  "Nangloi Jat",
  "Narasaraopet",
  "Nashik",
  "Navi Mumbai",
  "Navi Mumbai Panvel Raigad",
  "Navsari",
  "NDMC",
  "Neemuch",
  "Nellore",
  "Neyveli",
  "Nizamabad",
  "Noida",
  "North Barrackpur",
  "North Dum Dum",
  "Ongole",
  "Orai",
  "Osmanabad",
  "Ozhukarai",
  "Palakkad",
  "Palanpur",
  "Pali",
  "Pallavaram",
  "Palwal",
  "Panchkula",
  "Panihati",
  "Panipat",
  "Panvel",
  "Parbhani",
  "Patan",
  "Pathankot",
  "Patiala",
  "Patna",
  "Pilibhit",
  "Pimpri and Chinchwad",
  "Pithampur",
  "Porbandar",
  "Port Blair",
  "Proddatur",
  "Puducherry",
  "Pudukkottai",
  "Pune",
  "Puri Town",
  "Purnia",
  "Purulia Prayagraj",
  "Rae Bareli",
  "Raichur",
  "Raiganj",
  "Raigarh",
  "Raipur",
  "Rajahmundry",
  "Rajapalayam",
  "Rajarhat Gopalpur",
  "Rajkot",
  "Rajnandgaon",
  "Rajpur Sonarpur",
  "Ramagundam",
  "Rampur",
  "Ranchi",
  "Ranibennur",
  "Raniganj",
  "Ratlam",
  "Raurkela",
  "Raurkela Industrial Township",
  "Rewa",
  "Rewari",
  "Rishra",
  "Rishikesh",
  "Robertson Pet",
  "Rohtak",
  "Roorkee",
  "Rudrapur",
  "Sagar",
  "Saharanpur",
  "Saharsa",
  "Salem",
  "Sambalpur",
  "Sambhal",
  "Sangli Miraj Kupwad",
  "Santipur",
  "Sasaram",
  "Satara",
  "Satna",
  "Sawai Madhopur",
  "Secunderabad",
  "Sehore",
  "Seoni",
  "Serampore",
  "Shahjahanpur",
  "Shamli",
  "Shikohabad",
  "Shillong",
  "Shimla",
  "Shimoga",
  "Shivpuri",
  "Sikar",
  "Silchar",
  "Siliguri",
  "Singrauli",
  "Sirsa",
  "Sitapur",
  "Siwan",
  "Solapur",
  "Sonipat",
  "South Dum Dum",
  "Srikakulam",
  "Srinagar",
  "Sujangarh",
  "Sultan Pur Majra",
  "Sultanpur",
  "Surat",
  "Surendranagar Dudhrej",
  "Suryapet",
  "Tadepalligudem",
  "Tadpatri",
  "Tambaram",
  "Tenali",
  "Thane",
  "Thanesar",
  "Thanjavur",
  "Thiruvananthapuram",
  "Thoothukkudi",
  "Thrissur",
  "Tiruchirappalli",
  "Tirunelveli",
  "Tirupati",
  "Tiruppur",
  "Tiruvannamalai",
  "Tiruvottiyur",
  "Titagarh",
  "Tonk",
  "Tumkur",
  "Udaipur (Rajasthan)",
  "Udaipur (Himachal Pradesh)",
  "Udaipur (Tripura)",
  "Udgir",
  "Udupi",
  "Ujjain",
  "Ulhasnagar",
  "Uluberia",
  "Unnao",
  "Uttarpara Kotrung",
  "Vadodara",
  "Valsad",
  "Vapi",
  "Varanasi",
  "Vasai Virar",
  "Vellore",
  "Veraval",
  "Vidisha",
  "Vijayawada",
  "Visakhapatnam",
  "Vizianagaram",
  "Warangal",
  "Wardha",
  "Yamunanagar",
  "Yavatmal",
  "Goa",
  "Pondicherry",
  "Rourkela"
];

export default indianCityList;
